import { Controller } from "@hotwired/stimulus"

// 画像の読み込み失敗時にフォールバック画像へ 1 回だけ差し替え、
// フォールバックが無い / それも失敗した場合は画像領域ごと非表示にする
export default class extends Controller {
  static values = { src: String }

  connect() {
    // controller 接続前に load / error が発火済みのケース（キャッシュ済み 404 等）を拾う
    if (this.element.complete) this.verify()
  }

  // 失効した画像 URL に 1x1 GIF の実体を 404 で返す配信元があり、ブラウザは読み込み成功として
  // 扱うため error が発火しない。実寸で失敗を見分ける（1px のサムネイルは実在しない）
  verify() {
    if (this.element.naturalWidth <= 1) this.failed()
  }

  failed() {
    if (this.hasSrcValue && this.srcValue) {
      const src = this.srcValue
      this.srcValue = ""
      this.element.src = src
    } else {
      this.element.parentElement.style.display = "none"
    }
  }
}
